import { ApiErrorMap } from '@common/interfaces';
import {
  PassengerInformationRequestPassengerInformationData,
  PassengerInformationRequestPassengerInformationParts,
} from './passenger-information/passenger-information.state';
import { GetBasicReservationInformationState } from '@lib/store';
import { GetCartState } from '@common/store/get-cart/get-cart.state';

/**
 * 搭乗者情報が配列になるので配列にしやすいよう定義
 */
export interface PassengerInformationRequestPassengerInformationDataGroup {
  data: PassengerInformationRequestPassengerInformationData;
  parts: PassengerInformationRequestPassengerInformationParts;
}

/**
 * 搭乗者情報入力で使用するキャッシュ情報取得
 * @param lang 言語キー
 * @returns 搭乗者情報入力で使用するキャッシュ情報
 */
export function getPassengerInformationRequestMasterKey(lang: string) {
  return [
    { key: 'countryAll', fileName: 'Country_All' },
    { key: 'm_office', fileName: 'Office_All' },
    { key: 'langCodeConvert_All', fileName: 'LangCodeConvert_All' },
    { key: 'm_mileage_program_i18n_all', fileName: `m_mileage_program_i18n_all_${lang}` },
    {
      key: 'Country_WithPosCountryByContactTelNumberCountryFlg',
      fileName: `Country_WithPosCountryByContactTelNumberCountryFlg_${lang}`,
    },
    {
      key: 'Country_CountryI18n_All',
      fileName: `Country_CountryI18n_All_${lang}`,
    },
    {
      key: 'Country_WithPosCountryForSmsSendTelNumber',
      fileName: `Country_WithPosCountryForSmsSendTelNumber_${lang}`,
    },
    {
      key: 'Country_CountryI18n_All',
      fileName: `Country_CountryI18n_All_${lang}`,
    },
    { key: 'ListData_All', fileName: 'ListData_All' },
    { key: 'Property_ForAkamaiCache', fileName: 'Property_ForAkamaiCache' },
    { key: 'Airport_All', fileName: 'Airport_All' },
  ];
}
/**
 * 搭乗者更新APIのエラーレスポンスに対するエラーマップ
 */
export const PassengerInformationRequestApiErrorMap: ApiErrorMap = {
  EBAZ000157: {
    isRetryableError: false,
    errorMsgId: 'E0333',
  },
  EBAZ000301: {
    isRetryableError: true,
    errorMsgId: 'E0466',
  },
  EBAZ000308: {
    isRetryableError: true,
    errorMsgId: 'E0467',
  },
  EBAZ000307: {
    isRetryableError: true,
    errorMsgId: 'E0465',
  },
  EBAZ000309: {
    isRetryableError: true,
    errorMsgId: 'E0468',
  },
  EBAZ000302: {
    isRetryableError: true,
    errorMsgId: 'E0462',
  },
  EBAZ000297: {
    isRetryableError: true,
    errorMsgId: 'W1314',
  },
};

/**
 * 動的文言に渡すパラメータ
 * @param getCartReply カート情報
 * @param getBasicReservationInformationReply 予約基本情報
 */
export interface PassengerInformationRequestDynamicParams {
  getCartReply?: GetCartState;
  getBasicReservationInformationReply?: GetBasicReservationInformationState;
}
export function defaultPassengerInformationRequestDynamicParams(): PassengerInformationRequestDynamicParams {
  return {
    getCartReply: undefined,
    getBasicReservationInformationReply: undefined,
  };
}
